import React, { useState } from "react";
import logo from "../assets/img/logo.svg";
import prev_arrow from "../assets/img/prev_arrow.svg";
import next_arrow from "../assets/img/next_arrow.svg";

const Step5 = ({ setStep, setFormdata, formData, setStep5Status }) => {
  const [referralPartnerError, setReferralPartnerError] = useState(false); // Error state for referral partner

  // Handle Next button click
  const handleNext = () => {
    if (!formData?.referral_partner) {
      setReferralPartnerError(true); // Show error if referral partner is empty
    } else {
      setStep(6); // Proceed to the next step if referral partner is valid
      setStep5Status(true); // Mark step 5 as completed
    }
  };

  return (
    <>
      <div class="top_logo_block">
        <div class="logo">
          <a href="">
            <img src={logo} alt="" />
          </a>
        </div>
      </div>

      <div class="step_body">
        <div class="step_form">
          <div class="form_block box_width_lg_two">
            <h1>
              Who are good referral partners to give and receive business?
            </h1>
            <div class="input_fields">
              <textarea
                placeholder="Type your info about your referral partners"
                value={formData?.referral_partner || ""}
                onChange={(e) => {
                  setFormdata((prevState) => ({
                    ...prevState,
                    referral_partner: e.target.value, // Update the referral partner field
                  }));
                  setReferralPartnerError(false); // Clear error on input change
                }}
              ></textarea>
              {referralPartnerError && (
                <p style={{ color: "red" }}>
                  Referral partner information is required.
                </p>
              )}
            </div>
          </div>

          <div class="btn_block">
            <a onClick={() => setStep(4)}>
              <img src={prev_arrow} alt="" /> <span>Prev</span>
            </a>
            <a onClick={handleNext} class="nxt_btn">
              <span>Next</span> <img src={next_arrow} alt="" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step5;